import React from 'react';
import { Button } from 'react-bootstrap';
import { FaPencilAlt } from 'react-icons/fa';
import CalendarEvent from './CalendarEvent';
import { getAppEventEditTarget } from './calendarEventTypes';

/**
 * Shared per-event row content — title/description/amount + the
 * Editar/Eliminar (Google) or Editar fecha (app-native) action buttons.
 * Extracted so CalendarDayModal (week/day view) and CalendarDetailPanel
 * (month view) don't duplicate the Google/AppEventDateModal wiring. The
 * caller supplies its own outer wrapper (ListGroup.Item vs. a plain div).
 */
function CalendarEventRow({ event, onEditGoogleEvent, onDeleteGoogleEvent, onEditAppEvent }) {
	const isGoogleEvent = event.type === 'google-event';
	const appEditTarget = !isGoogleEvent ? getAppEventEditTarget(event) : null;

	return (
		<div className='tw:flex tw:items-center tw:justify-between tw:gap-3 tw:w-full'>
			<div className='tw:flex tw:items-center tw:flex-1 tw:min-w-0'>
				<CalendarEvent event={event} onClick={() => {}} compact />
				<div className='tw:ml-3 tw:min-w-0'>
					<div className='tw:font-semibold tw:text-ink-0 tw:text-[13px] tw:truncate'>{event.title}</div>
					{event.description && (
						<div className='tw:text-[11.5px] tw:text-ink-3 tw:truncate'>{event.description}</div>
					)}
					{event.metadata?.amount && (
						<div className='tw:text-[12px] tw:text-ink-2'>
							${event.metadata.amount.toLocaleString()} {event.metadata.currency || ''}
						</div>
					)}
				</div>
			</div>
			<div className='tw:flex tw:items-center tw:gap-2 tw:shrink-0'>
				{isGoogleEvent && (
					<>
						<Button
							variant='outline-secondary'
							size='sm'
							onClick={(e) => { e.stopPropagation(); onEditGoogleEvent(event); }}
						>
							Editar
						</Button>
						<Button
							variant='outline-danger'
							size='sm'
							onClick={(e) => { e.stopPropagation(); onDeleteGoogleEvent(event); }}
						>
							Eliminar
						</Button>
					</>
				)}
				{appEditTarget && (
					<button
						type='button'
						title='Editar fecha'
						onClick={(e) => { e.stopPropagation(); onEditAppEvent(event); }}
						className='tw:w-6 tw:h-6 tw:rounded-token tw:flex tw:items-center tw:justify-center tw:text-ink-2 tw:hover:bg-surface-2 tw:hover:text-accent tw:bg-transparent tw:border-0'
					>
						<FaPencilAlt size={11} />
					</button>
				)}
				{!isGoogleEvent && !appEditTarget && (
					<span className='tw:text-ink-3 tw:text-[12px]'>→</span>
				)}
			</div>
		</div>
	);
}

export default CalendarEventRow;
